var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSystem = function SvgSystem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/currentColor/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.825 1.385v4.474H1.377V1.385h4.448ZM7.202 0H0v7.244h7.202V0ZM5.825 15.236v4.473H1.377v-4.473h4.448Zm1.377-1.385H0v7.243h7.202v-7.243Zm12.42 1.385v4.473h-4.475v-4.473h4.475Zm1.35-1.385h-7.203v7.243h7.202v-7.243Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.607 7.244v6.634",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.622 29.086v4.473h-4.475v-4.473h4.475Zm1.35-1.385h-7.203v7.243h7.202v-7.243Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.832 21.122v6.634m-4.035-10.249H7.201",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
export default SvgSystem;